"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOpenLinkEvent = exports.isViewableEvent = exports.isResourceLoadCompleteEvent = void 0;
function isResourceLoadCompleteEvent(event) {
    return event.getType() === 'resource_load_complete';
}
exports.isResourceLoadCompleteEvent = isResourceLoadCompleteEvent;
function isViewableEvent(event) {
    return event.getType() === 'viewable_event';
}
exports.isViewableEvent = isViewableEvent;
function isOpenLinkEvent(event) {
    return event.getType() === 'open_link';
}
exports.isOpenLinkEvent = isOpenLinkEvent;
//# sourceMappingURL=tracking-event.js.map